import React from 'react';
import FeatureBento from '../components/site/FeatureBento';
import CaseStudies from '../components/site/CaseStudies';
import { PageHero, PageShell, QuoteBand, QuoteButton } from '../components/site/PageParts';
import useSeo from '../hooks/useSeo';

export default function LiveEvents() {
  useSeo({
    title: 'Live Event Printing & Merch Booths | Pusha Teez',
    description:
      'Live merch printing and fully managed merch booths for festivals, brand activations and corporate events — a Pusha Teez live events service.',
    path: '/live-events',
  });
  return (
    <PageShell testid="live-events-page">
      <PageHero
        eyebrow="Live events"
        title="Live Event"
        accent="Printing"
        intro="Elevate your event with on-site customization designed for impact. From live printing to fully managed merch booths, we bring production to your audience."
      >
        <div className="mt-10"><QuoteButton label="Get a Live Event Quote" testid="live-events-quote-btn" /></div>
      </PageHero>
      <FeatureBento />
      <CaseStudies kind="live-printing" title="Live Printing" accent="Projects" moreLink={{ to: '/work?type=live-printing', label: 'View on the Work page' }} />
      <QuoteBand title="Bring live printing to your event" label="Get a Live Event Quote" />
    </PageShell>
  );
}
